// saveFailureNotice — a change that did not save must never look saved.
//
// Many callers catch a failed save and only log it (38 whole-project saves
// alone did), so the edit stayed on screen, was gone on the next reload, and
// nobody was told. apiFetch reports every failed WRITE here; the one
// <SaveFailureNotice /> mounted in App shows it. Identical notices within a
// few seconds are merged, so a burst of autosaves failing reads as one.

export const SAVE_FAILED_EVENT = 'pidly:save-failed';

const MERGE_WINDOW_MS = 6000;
const lastShown = new Map();

/** Announce a failed write. `message` is what went wrong, in plain words. */
export function reportSaveFailure({ title = 'Your change was not saved', message = '', kind = 'error' } = {}) {
  const key = `${kind}|${title}|${message}`;
  const now = Date.now();
  const prev = lastShown.get(key);
  if (prev && now - prev < MERGE_WINDOW_MS) return;
  lastShown.set(key, now);
  try {
    window.dispatchEvent(new CustomEvent(SAVE_FAILED_EVENT, { detail: { title, message, kind } }));
  } catch { /* no window (tests) */ }
}
